import { useResource } from '@landsbankinn/l16n';
import { Box, Notification, Span, UnstyledLink } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import {
  OperationalStatusEnum,
  type OperationalStatusFragment,
} from '../../gql/__generated__/graphql';
import { res } from './TopNotification.res';

export function TopNotification(operationalStatus: OperationalStatusFragment) {
  const { r } = useResource();
  const { isMobile } = useScreenSize();

  if (
    operationalStatus.status !== OperationalStatusEnum.DegradedPerformance &&
    operationalStatus.status !== OperationalStatusEnum.Info
  ) {
    return null;
  }

  const { message, status } = operationalStatus;

  if (!message?.title) return null;

  const variant =
    status === OperationalStatusEnum.DegradedPerformance
      ? 'tertiary'
      : 'primary';

  const content = (
    <>
      <strong>{message.title}</strong> {message.description}
      {message.link && (
        <>
          {' '}
          <Span
            as={UnstyledLink}
            href={message.link}
            textDecoration="underline"
          >
            {r(res.readMore)}
          </Span>
        </>
      )}
    </>
  );

  if (isMobile) {
    return (
      <Box shrink="0">
        <Notification content={content} textAlign="center" variant={variant} />
      </Box>
    );
  }

  return (
    <Box marginVertical="36">
      <Notification
        fullWidth={false}
        icon="info"
        variant={variant}
        content={content}
      />
    </Box>
  );
}
